export default __webpack_public_path__ + "static/media/logout-20x20.d408cb65.svg";